// Renewal-pipeline legend — FE-035 / spec §7.0.6.
//
// Tier 1 ships a small text-and-swatch legend; the chart's bars
// reuse the same swatch classes so the visual link is obvious.

import {
  RENEWAL_STATUS_META,
  RENEWAL_STATUS_ORDER,
  type RenewalStatusKey,
} from "./statusMeta";


export function RenewalLegend() {
  return (
    <ul
      data-testid="renewal-legend"
      role="list"
      className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-text-secondary"
    >
      {RENEWAL_STATUS_ORDER.map((status: RenewalStatusKey) => {
        const meta = RENEWAL_STATUS_META[status];
        return (
          <li
            key={status}
            data-testid={`renewal-legend-${status}`}
            className="inline-flex items-center gap-1.5"
          >
            <span
              aria-hidden="true"
              className={`inline-block h-2 w-2 rounded-sm ${meta.swatch}`}
            />
            <span>{meta.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
